import {FTPUser} from './ftp-user.model';

export class FTPConfig {
    constructor(
        public userPermissions: FTPUser[] = []
    ) { }
}
